var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-line-chart"},[_c('div',{staticClass:"report-line-chart-wrapper"},[_c('div',{staticClass:"report-line-chart-inner"},[_c('e-chart',{ref:"chart"})],1)]),_vm._v(" "),_c('div',{staticClass:"report-line-chart-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4088b1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportChart/ReportLineChart.vue
// module id = null
// module chunks = 